import { TicketWidgetItemArray } from './ticket.widget.item';
import { TicketTotals } from './ticket.totals';

export interface ITicketGlobals {
    Widgets: TicketWidgetItemArray;
    Totals: TicketTotals;

}

export class TicketGlobals  implements ITicketGlobals {
    Widgets: TicketWidgetItemArray;
    Totals: TicketTotals;
}
